import { type ReactNode, useId } from 'react';
import { cn } from '@/shared/lib/cn';
import { Input } from '@/shared/ui/input/input';
import { CONTROL_CLASS } from './control-class';
import { FieldShell } from './field-shell';

type TextFieldProps = {
  readonly label: string;
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly error?: string | undefined;
  readonly hint?: ReactNode;
  readonly required?: boolean;
  readonly className?: string;
  readonly placeholder?: string;
  readonly suggestions?: readonly string[];
  readonly type?: 'text' | 'date' | 'url' | 'password';
  readonly inputMode?: 'text' | 'decimal' | 'numeric' | 'url';
  readonly autoComplete?: string;
  readonly autoFocus?: boolean;
};

export function TextField({
  value,
  onChange,
  suggestions,
  placeholder,
  type = 'text',
  inputMode,
  autoComplete,
  autoFocus,
  ...shell
}: TextFieldProps) {
  const id = useId();
  const listId = suggestions?.length ? `${id}-list` : undefined;
  return (
    <FieldShell id={id} {...shell}>
      <Input
        id={id}
        type={type}
        inputMode={inputMode}
        autoComplete={autoComplete}
        value={value}
        placeholder={placeholder}
        list={listId}
        autoFocus={autoFocus}
        aria-invalid={shell.error ? true : undefined}
        onChange={(event) => onChange(event.target.value)}
        className={cn(CONTROL_CLASS, type === 'date' && 'block')}
      />
      {listId && (
        <datalist id={listId}>
          {suggestions?.slice(0, 30).map((suggestion) => (
            <option key={suggestion} value={suggestion} />
          ))}
        </datalist>
      )}
    </FieldShell>
  );
}
